"use client";

import type { Locale } from "@i18n/react";
import { useLocale } from "@i18n/react";
import { HallowABFlag, useMixpanel } from "@packages/ab";
import { useRequestMe } from "@packages/sdk";
import { useMemo } from "react";

import { isValidKidsLocale } from "../lib/utils/isValidKidsLocale";

export const useIsKidsProfilesVisible = (): boolean => {
  const { query: meQuery } = useRequestMe();
  const { flags } = useMixpanel();
  const locale = useLocale();

  return useMemo(() => {
    if (meQuery.data?.is_kid || meQuery.data?.has_parent_pin) return true;

    if (!flags?.[HallowABFlag.WebKidsProfileLaunch]?.isTargeted) return false;

    return (
      isValidKidsLocale(locale as Locale) && meQuery.data?.country === "US"
    );
  }, [
    meQuery.data?.is_kid,
    meQuery.data?.has_parent_pin,
    flags?.[HallowABFlag.WebKidsProfileLaunch]?.isTargeted,
    meQuery.data?.country,
    locale,
  ]);
};
